import { UseFormReturn } from 'react-hook-form';
import { FormProvider } from 'react-hook-form';

import { ButtonWithStateAndLabel } from '@xemplo/fullscreen-modal-header';
import { HeaderIconMode } from '@xemplo/header-icon';
import {
  BtnWithLabel,
  Modal,
  ModalDialogSlot,
  useModalDialog,
} from '@xemplo/modal-dialog';

import * as S from './modal/modal.styles';
import { ModalHeaderIcon } from './modal/modal-header-icon';
import { FormFields } from './create-amendment.types';

interface CreateAmendmentModalProps {
  modalDialog: ReturnType<typeof useModalDialog>;
  methods: UseFormReturn<FormFields>;
  handleClose: () => void;
  getFormStep: () => React.ReactNode;
  primaryButton?: ButtonWithStateAndLabel;
  tertiaryButton?: BtnWithLabel;
}

export function CreateAmendmentModal({
  modalDialog,
  methods,
  handleClose,
  getFormStep,
  primaryButton,
  tertiaryButton,
}: Readonly<CreateAmendmentModalProps>) {
  return (
    <Modal.Dialog {...modalDialog.dialogProps}>
      {modalDialog.isOpen && (
        <FormProvider {...methods}>
          <Modal>
            <Modal.Slot
              name={ModalDialogSlot.CloseButton}
              render={
                <Modal.CloseButton
                  onClick={handleClose}
                  id="create-amendment-close-button"
                  ariaLabel="close modal"
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Header}
              render={
                <Modal.Header
                  title="New Amendment"
                  headerIcon={{
                    icon: <ModalHeaderIcon />,
                    mode: HeaderIconMode.AdminTimesheet,
                  }}
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Body}
              render={
                <Modal.Body>
                  <S.StyledForm>{getFormStep()}</S.StyledForm>
                </Modal.Body>
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Footer}
              render={
                <Modal.Footer btnPrimary={primaryButton} btnTertiary={tertiaryButton} />
              }
            />
          </Modal>
        </FormProvider>
      )}
    </Modal.Dialog>
  );
}
